import React, { useState, useEffect } from "react";
import { Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import pdf from "../../Assets/../Assets/Bayoudhi_Firas_CV.pdf";
import { AiOutlineDownload } from "react-icons/ai";
import { Document, Page, pdfjs } from "react-pdf";
import { usePortfolioSettings } from "../../hooks/usePortfolioData";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

function ResumeNew() {
  const [width, setWidth] = useState(1200);
  const { settings } = usePortfolioSettings();
  
  // Default to local PDF if no URL is set
  const defaultPdf = pdf;
  
  // Get resume PDF URL from settings, fallback to default
  const resumePdfUrl = settings?.resume_pdf_url && settings.resume_pdf_url.trim() !== '' 
    ? settings.resume_pdf_url 
    : defaultPdf;
  
  const resumeLink = resumePdfUrl;

  useEffect(() => {
    setWidth(window.innerWidth);
  }, []);

  return (
    <div>
      <Container fluid className="resume-section">
        <Particle />
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button
            variant="primary"
            href={resumePdfUrl}
            target="_blank"
            style={{ maxWidth: "250px" }}
            download
          >
            <AiOutlineDownload />
            &nbsp;Download CV
          </Button>
        </Row>

        <Row className="resume">
  <Document file={resumeLink} className="d-flex justify-content-center">
    <Page 
      pageNumber={1} 
      scale={width > 786 ? 1.2 : 0.45}
      renderTextLayer={false}
      renderAnnotationLayer={false}
    />
    <Page 
      pageNumber={2} 
      scale={width > 786 ? 1.2 : 0.45}
      renderTextLayer={false}
      renderAnnotationLayer={false}
    />
  </Document>
</Row>

        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button
            variant="primary"
            href={resumePdfUrl}
            target="_blank"
            style={{ maxWidth: "250px" }}
            download
          >
            <AiOutlineDownload />
            &nbsp;Download CV
          </Button>
        </Row>
      </Container>
    </div>
  );
}

export default ResumeNew;
